import { Component } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { AddCreditRequest } from '../../models/ss-api/requests/add.credit.request';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { Router } from '@angular/router';

export interface IAddCreditDialogModel {
    title: string;
    MemberID: number;
}

@Component({
    selector: 'add-credit-dialog',
    styleUrls: ['./add.credit.dialog.css'],
    templateUrl: './add.credit.dialog.html'
})
export class AddCreditDialog extends DialogComponent<IAddCreditDialogModel, boolean> implements IAddCreditDialogModel {
    title: string;
    MemberID: number;

    date: Date = new Date();
    description: string = 'description';
    amount: number = 100;

    constructor(private api: ssApiService, dialogService: DialogService, private sweetAlertService: SweetAlertService, public router: Router) {
        super(dialogService, router);
    }

    async confirm() {
        // we set dialog result as true on click on confirm button,
        // then we can get dialog result from caller code

        let request = new AddCreditRequest();

        request.MemberID = this.MemberID;
        request.Description = this.description;
        request.Amount = this.amount;

        await this.sweetAlertService.swal(
            {
                title: 'Add Credit?',
                text: 'Are you sure you want to add a credit of $' + this.amount + '?',
                type: 'warning',
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: 'Yes, add credit!',
                cancelButtonText: 'Cancel',
                allowOutsideClick: false,
                preConfirm: () => {
                    return this.api.AddCredit(request).toPromise();
                }
            })
            .then(async (response: any) => {
                this.result = true;
                this.close();
                this.sweetAlertService.swal(
                    {
                        title: 'Credit Added',
                        text: 'Shout \'HOORAY!\'',
                        type: 'success',
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 1500
                    })
                    .then((response: any) => {

                    }, (dismiss) => {

                        return;
                    }); // keep this line to prevent promise error;
            }, (dismiss) => {
                return;
            })
            .catch(error => {
                this.sweetAlertService.swal(
                    {
                        title: 'Error',
                        text: error.message,
                        type: 'error',
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonText: 'OK',
                    })
                    .then((response: any) => {
                        this.result = false;
                        this.close();
                    }, (dismiss) => {
                        return;
                    }); // keep this line to prevent promise error;
            });



    }


}
